import axios from "axios";

const axiosInstance = axios.create({
  baseURL: `https://api.wutsthedeal.com/`,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("WutsDealsUserToken");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('WutsDealsUserToken')
      window.location.replace('/login')
    }
    return Promise.reject(error);
  }
);


export default axiosInstance;
